<template>
<div class="sepa-component">
  <v-divider></v-divider>
  <v-row align="center" justify="center">
    <div class="sepa-content">
      <div class="amount">
        {{amount | currency(null, true)}}
      </div>
      <div class="client">
        <div class="name">
          {{client.lastname}} {{client.firstname}}
        </div>
        <div class="address">
          {{client.address}}
        </div>
        <div class="city">
          {{client.zip}} {{client.city}}
        </div>
      </div>
      <div class="bank">
        {{company.companyBank}}
      </div>
      <div class="company">
        <div class="name">
          {{company.companyName}} {{ company.companyType }}
        </div>
        <div class="address">
          {{company.companyAddress}}
        </div>
        <div class="city">
          {{company.companyZip}} {{company.companyCity}}
        </div>
      </div>
      <div class="invoiceId">
        {{invoiceId}}/{{client.clientId}}
      </div>
      <img src="img/sepa_fr.png" width="100%">
    </div>
  </v-row>
  </div>
</template>
<script>
export default {
  name: 'sepa',
  props: ['amount', 'client', 'company', 'invoiceId'],
  data () {
    return {}
  },
  methods: {

  }
}
</script>
<style lang="scss">
.sepa-component {
  page-break-after: always;
  margin: 0;
  padding: 0;
  .sepa-content {
    position: relative;
    width:100%;
    letter-spacing: 2px;
    line-height: 16px;
    .amount {
      letter-spacing: 12px;
      position: absolute;
      top:98px;
      right:6px;
    }
    .client {
      position: absolute;
      top:165px;
      left:134px;
    }
    .bank {
      position: absolute;
      top:230px;
      left:134px;
      letter-spacing: 11px;
    }
    .company {
      position: absolute;
      top:295px;
      left:135px;
    }
    .invoiceId {
      position: absolute;
      top:360px;
      left:137px;
      letter-spacing: 11px;
    }
  }
}
</style>
